import { useSyncExternalStore } from 'react';

const emptySubscribe = () => () => undefined;

/**
 * Returns `false` on the server / during the first paint and `true` once
 * hydrated on the client — without a synchronous setState inside an effect
 * (which the repo's React-compiler lint forbids). Use it to gate browser-only
 * subtrees (e.g. components that read `document`/`window` during render) so
 * they only render client-side.
 */
export function useHydrated(): boolean {
  return useSyncExternalStore(
    emptySubscribe,
    () => true, // client
    () => false, // server
  );
}
